<template>
  <div class="print-sheet-title" v-show="title">
    {{ title }}
  </div>
  <div class="psd-group-holder" :class="getOrientation">

      <PrintSprinklerData
        v-for="(data) in data"
        :data="data"
        :record="$props.record"
      />

  </div>
</template>

<script>
import PrintSprinklerData from './PrintSprinklerData.vue';
import { usePrintStore } from '../../../store/PrintStore';

export default {
  name: 'PrintSprinkler',
  components: { PrintSprinklerData },
  props: ['record', 'data', 'title'],
  computed: {
    getOrientation () {
      return usePrintStore().getOrientation === 'portrait'
        ? 'psd-group-holder-portrait'
        : '';
    },
  },
};
</script>

<style scoped>
.psd-group-holder {
  display: flex;
  flex-direction: column;
  max-height: 400px;
  margin-right: 20px;
}
.psd-group-holder-portrait {
  max-height: none;
}
.print-sheet-title {
  font-weight: bold;
  width: 120px;
  font-size: 15px;
  text-align: right;
  margin-left: 12px;
  line-height: 1;/*
  margin-bottom: -6px;*/
  margin-bottom: 25px;
}
</style>
